import * as ActionTypes from '../ActionTypes';

export const GetMPRIDAction = (params, callback) => {
    return {
        type: ActionTypes.ATS_MPRID_GET_REQUEST,
        params,
        callback
    };
};

export const UpdateMPRIDAction = (params, callback) => {
    return {
        type: ActionTypes.ATS_MPRID_UPDATE_REQUEST,
        params,
        callback
    };
};

